import React from 'react';
import LayoutHelper from './../../helpers/Layout';
import SimpleTooltip from '../../common/tooltip/SimpleTooltip';

class Reload extends React.Component {
  handleClick = () => {
    LayoutHelper.reload();
  };

  render() {
    return (
      <li>
        <SimpleTooltip
          message={'layout.tooltipSideBar.REFRESH_WORKSPACE'}
          position={'right'}
          isI18n={true}
          appendClassName={'d-block'}
          appendStyle={{ zIndex: 99999 }}
        >
          <a href="#" onClick={this.handleClick}>
            <i className="icon-refresh" />
          </a>
        </SimpleTooltip>
      </li>
    );
  }
}

export default Reload;
